export function appendSlashToUrl(url = '', appendBothSides = false) {
  if (appendBothSides) {
    if (!url.endsWith('/')) {
      url = url + '/';
    }
  }
  return url?.startsWith('/') ? url : `/${url}`;
}
